import Modal from 'foundations/modal';

export default class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.fadeInAnimationInterval = null;
        this.fadeOutAnimationInterval = null;
        this.notificationEl = null;
        this.holdNotificationTimeout = null;
        this.changeNotificationTimeout = null;
        this.notificationContainerEl = document.querySelector('.notification-container');
    }

    render() {
        return (
            <Modal style={{ opacity: 0, padding: '25px 50px', backgroundColor: '#F6F6F6' }}>
                {this.props.children}
            </Modal>
        );
    }

    animateNotification() {
        this.notificationEl = document.querySelector('.modal');
        this.fadeInAnimationInterval = setInterval(this.fadeInAnimation.bind(this), 40);
    }

    fadeInAnimation() {
        if (parseFloat(window.getComputedStyle(this.notificationEl).opacity) === 1) {
            window.clearInterval(this.fadeInAnimationInterval);
            this.holdNotificationTimeout = setTimeout(this.initfadeOutInterval.bind(this), 1600);
        } else {
            this.changeOpacity(0.1);
        }
    }

    initfadeOutInterval() {
        this.fadeOutAnimationInterval = setInterval(this.fadeOutAnimation.bind(this), 40);
    }

    fadeOutAnimation() {
        if (parseFloat(window.getComputedStyle(this.notificationEl).opacity) === 0) {
            window.clearInterval(this.fadeOutAnimationInterval);
            this.removeElement();
        } else {
            this.changeOpacity(-0.1);
        }
    }

    removeElement() {
        if (document.querySelector('.modal')) {
            ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this).parentNode);
        }
    }

    changeOpacity(amount) {
        this.notificationEl.style.opacity = Number(window.getComputedStyle(this.notificationEl).opacity) + amount;
    }

    updateNotification() {
        clearTimeout(this.changeNotificationTimeout);
        clearInterval(this.fadeInAnimationInterval);
        clearInterval(this.fadeOutAnimationInterval);
        clearTimeout(this.holdNotificationTimeout);
        this.notificationEl.style.opacity = 1;
        this.changeNotificationTimeout = setTimeout(this.initfadeOutInterval.bind(this), 1600);
    }

    componentDidMount() {
        this.animateNotification();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            this.updateNotification();
        }
    }

    componentWillUnmount() {
        this.notificationContainerEl.parentNode.removeChild(this.notificationContainerEl);
    }
}
